import Axios from '../../libs/strataIns';

export default {
  state: {
    // settings: [],
    settings: {},
    
    // ordersStatus: [],
    // orderStatus: {},
  },

  getters: {
    // suppliers: (state) => state.suppliers,
    settings: (state) => state.settings,
    // ordersStatus: (state) => state.ordersStatus,
    // orderStatus: (state) => state.orderStatus,
  },

  mutations: {
    // setSuppliers(state, payload) {
    //   state.suppliers = [...payload]
    // },
    setSettings(state, payload) {
      state.settings = {...payload}
    },

  },

  actions: {
    getSettings({commit}, payload) {
      return new Promise ((resolve, reject) => {
        Axios.post(`/admin/settings`, {
        })
        .then(res => {
          if(res.data.results != null) {
            commit('setSettings', res.data.results);
            resolve(res);
          }else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        });
      })
    }, 
    updateSettings({commit}, payload) {
      console.log(payload)
      return new Promise ((resolve, reject) => {
        Axios.post(`/admin/settings/save`, {
          settings: {
            AppName: payload.AppName,
            location_company: payload.location_company,
            address: {
              ar: payload.address,
              en: payload.address,
            },
            facebook_pixel: payload.facebook_pixel,
            google_tag_manager: payload.google_tag_manager,
            maps_api_key: payload.maps_api_key,
            social_media_links: payload.social_media_links,
            keywords: payload.keywords,
            site_meta_title: payload.site_meta_title,
            site_meta_description: payload.site_meta_description,
            copy_rights: payload.copy_rights,
            email: payload.email,
            phone: payload.phone,
            fax: payload.fax,
            logo: payload.logo,
            favicon: payload.favicon,
            colorTheme: payload.colorTheme,
            fonts: payload.fonts,
            statistics: payload.statistics,
            footerNumberOfColomns: payload.footerNumberOfColomns,
            footerSections: payload.footerSections,
            logo: payload.base64,
            ShippingRules: payload.ShippingRules,
            // ShippingRules: {
            //     "default": "3.5"
            // },
            // minProducts: payload.minProducts,
          }
        })
        .then(res => {
          if(res.data.results != null) {
            resolve(res);
          }else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        });
      })
    }, 
    
  }
}